<template>
    <div class="container">
        <img class="background-image" :src="preText + bgImg" alt="">
        <div class="first-item" v-if="bigItem">
          <div class="big-img-link" @click="clickBigImgLink(bigItem)">
            <img :src="bigItem.coverImage" alt="">
            <div class="big-img-link-title">
              <span class="big-img-link-title-icon"></span>
              <span>{{ bigItem.productName }}</span>
            </div>
          </div>
        </div>
        <div :class="{'more-btn': true, 'more-right': index % 2 > 0 }" @click="handleMore" code-stm="event, PAGEURL, 查看更多">查看更多</div>
        <div class="item-list">
            <div class="item" v-for="(item, _index) in filteredItems" :key="_index">
                <img :src="item.coverImage" alt="" @click="clickItem(item)" code-stm="event, PAGEURL, 查看商品详情">
                <div class="items-list-title">
                  <div class="items-list-title-icon"></div>
                  <div>{{ item.productName }}</div>
                </div>
            </div>
        </div>
    </div>
  </template>

  <script>
  import { isPortraitFun } from "@/utils/utils.js";
  import { queUrl } from "@/config/base";

  export default {
    props: {
      // 一级分类对象，用于请求推荐商品（与 PC 端组件保持一致）
      category: {
        type: Object,
        default: () => ({}),
      },
      index: {
        type: Number,
        required: true,
        default: 0
      },
      itemList: {
        type: Array,
        required: true,
        default: () => []
      },
      bgImg: {
        type: String,
        required: true,
        default: ''
      },
      bigImgLink: {
        type: String,
        required: true,
        default: ''
      },
      bigColor: {
        type: String,
        default: '#000'
      },
      color: {
        type: String,
        default: '#000'
      },
    },
    data() {
      return {
        isPortrait: isPortraitFun(),
        preText:'https://www.kia.cn',
        // 实际用于渲染的列表，初始用父组件传入的数据，后续如果有接口数据则覆盖
        items: [],
      };
    },
    computed: {
      // 数据源优先使用接口返回的 items，没有接口数据时退回到父组件传入的 itemList
      itemsSource() {
        if (Array.isArray(this.items) && this.items.length) {
          return this.items;
        }
        return this.itemList || [];
      },
      // 大图使用的 item 下标：index % 2 === 0 时用第 0 个，否则用第 1 个
      bigItemIndex() {
        return this.index % 2 === 0 ? 0 : 1;
      },
      // 大图对应的商品
      bigItem() {
        if (!Array.isArray(this.itemsSource) || this.itemsSource.length === 0) return null;
        return this.itemsSource[this.bigItemIndex] || null;
      },
      // 列表中不再展示已经给大图用掉的那个 item
      filteredItems() {
        if (!Array.isArray(this.itemsSource) || this.itemsSource.length === 0) return [];
        const skip = this.bigItemIndex;
        return this.itemsSource.filter((_, i) => i !== skip);
      },
    },
    created: function () {
      const href = window.location.href || "";
      if (href.includes("uat.kia.cn")) {
        this.preText = "https://uat.kia.cn";
      } else if (href.includes("www.kia.cn")) {
        this.preText = "https://www.kia.cn";
      } else {
        // 本地/测试环境
        this.preText = "https://uat.kia.cn";
      }
    },
    watch: {
      category: {
        handler(newVal) {
          if (newVal && newVal.catId) {
            this.fetchRecommendList(newVal.catId);
          }
        },
        immediate: true,
      },
      // 父组件如果直接传入静态 itemList，在接口没有数据时作为兜底
      itemList: {
        handler(newVal) {
          // 如果接口数据为空，则使用静态 itemList
          if ((!this.items || !this.items.length) && newVal && newVal.length) {
            // 这里不直接赋值给 items，而是让 computed itemsSource 自动回退
          }
        },
        immediate: true,
        deep: true,
      },
    },
    methods: {
      clickBigImgLink: function (item) {
        this.$router.push({
          path: '/mall/detail',
          query: {
            id: item.productId,
          },
        });
        // window.open(this.bigImgLink, '_blank');
      },
      clickItem: function (item) {
        this.$router.push({
          path: '/mall/detail',
          query: {
            id: item.productId,
          },
        });
        // window.open(item.link, '_blank');
      },
      async fetchRecommendList(catId) {
        try {
          const res = await this.$axios({
            method: "get",
            url: `${queUrl}api/shop/product/recommendList`,
            params: {
              categoryId: catId,
            },
          });
          if (res.data.code === 200) {
            this.items = res.data.rows || [];
          } else {
            this.items = [];
          }
        } catch (e) {
          console.warn("[MobPage] recommendList error:", e);
          this.items = [];
        }
      },
      handleMore() {
        this.$router.push({
          path: '/mallList',
          query: {
            parentId: this.category.catId,
            parentName: this.category.catName,
            forceRefresh: 1,
          }
        });
      }
    },
  };
  </script>

  <style lang="scss" scoped>
  @media (max-width: 767px) {
    .container {
        height: calc(1189 / 750 * 100vw);
        position: relative;
        width: 100%;
        user-select: none;
        z-index: 0;
    }
    .background-image {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .more-btn {
        position: absolute;
        top: calc(345 / 750 * 100vw);
        left: calc(100 / 750 * 100vw);
        width: calc(156 / 750 * 100vw);
        height: calc(56 / 750 * 100vw);
        background-color: #000;
        color: #fff;
        font-size: calc(22 / 750 * 100vw);
        text-align: center;
        line-height: calc(56 / 750 * 100vw);
        border-radius: calc(4 / 750 * 100vw);
        cursor: pointer;
    }
    .more-right {
      left: auto;
      right: calc(178 / 750 * 100vw);
    }
    .big-img-link {
        position: absolute;
        top: calc(422 / 750 * 100vw);
        left: calc(32 / 750 * 100vw);
        width: calc(686 / 750 * 100vw);
        height: calc(436 / 750 * 100vw);
        background-color: transparent;
    }
    .big-img-link-title {
      position: absolute;
      top: calc(18 / 750 * 100vw);
      left: calc(40 / 750 * 100vw);
      color: v-bind(bigColor);
      font-size: calc(17 / 750 * 100vw);
      text-align: center;
      line-height: calc(17 / 750 * 100vw);
      display: flex;
      align-items: flex-start;
    }
    .big-img-link-title-icon {
      flex: 0 0 auto;
      display: inline-block;
      width: calc(4 / 1920 * 100vw);
      height: calc(14 / 750 * 100vw); /* 跟文字同高，视觉齐平 */
      background-color: #C09D5A;
      margin-right: calc(10 / 1920 * 100vw);

    }
    .item {
      position: relative;
    }
    .items-list-title {
      position: absolute;
      bottom: calc(18 / 750 * 100vw);
      left: calc(10 / 750 * 100vw);
      color: v-bind(color);
      font-size: calc(17 / 750 * 100vw);
      text-align: center;
      line-height: calc(17 / 750 * 100vw);
      display: flex;
      align-items: baseline;
    }
    .items-list-title-icon {
      flex: 0 0 auto;
      display: inline-block;
      width: calc(4 / 1920 * 100vw);
      height: calc(14 / 750 * 100vw); /* 跟文字同高，视觉齐平 */
      background-color: #C09D5A;
      margin-right: calc(10 / 1920 * 100vw);

    }
    .item-list {
        position: absolute;
        top: calc(879 / 750 * 100vw);
        left: calc(32 / 750 * 100vw);
        width: calc(718 / 750 * 100vw);
        height: calc(239.34 / 750 * 100vw);
        display: flex;
        flex-wrap: nowrap;
        gap: calc(10 / 750 * 100vw);
        overflow-x: auto;
        overflow-y: hidden;
        background-color: transparent;
        padding-right: calc(32 / 750 * 100vw);
    }
    .item {
        flex: 0 0 auto;
        width: calc(239.34 / 750 * 100vw);
        height: calc(239.34 / 750 * 100vw);
        object-fit: cover;
        border-radius: calc(11.97 / 750 * 100vw);
        overflow: hidden;
    }
  }
  </style>
